/* eslint-disable no-undef */
import React, { Component } from "react";
// import {
//   GoogleMap,
//   Marker,
//   withGoogleMap,
//   withScriptjs
// } from "react-google-maps";
// import { SearchBox } from "react-google-maps/lib/components/places/SearchBox";
import ReactGA from "react-ga";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import ReactMapboxGl, { Layer, Feature } from "react-mapbox-gl";
// import { mapStyles } from "../../styling/mapStyles";
import { accessToken } from "../../accessToken";
import Geocoder from "./Geocoder";
import NavigationControl from "./NavigationControl";

const styles = {
  root: {
    textAlign: "center"
  },
  button: {
    margin: "10px"
  }
};

// const MyMapComponent = withScriptjs(
//   withGoogleMap(props => {
//     const inputProps = {
//       defaultZoom: 14,
//       defaultCenter: props.chosenPosition,
//       onClick: props.onClick,
//       clickableIcons: false,
//       defaultOptions: {
//         streetViewControl: false,
//         scaleControl: false,
//         mapTypeControl: false,
//         panControl: false,
//         zoomControl: false,
//         rotateControl: false,
//         fullscreenControl: false,
//         styles: mapStyles
//       }
//     };
//     if (
//       props.chosenPosition &&
//       props.actualPosition &&
//       props.chosenPosition.lat === props.actualPosition.lat
//     ) {
//       return (
//         <GoogleMap {...inputProps} center={props.chosenPosition}>
//           <SearchBox
//             ref={props.onSearchBoxMounted}
//             bounds={props.bounds}
//             controlPosition={google.maps.ControlPosition.TOP_LEFT}
//             onPlacesChanged={props.onPlacesChanged}
//           >
//             <input
//               type="text"
//               placeholder="Customized your placeholder"
//               style={{
//                 boxSizing: `border-box`,
//                 border: `1px solid transparent`,
//                 width: `240px`,
//                 height: `32px`,
//                 marginTop: `27px`,
//                 padding: `0 12px`,
//                 borderRadius: `3px`,
//                 boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
//                 fontSize: `14px`,
//                 outline: `none`,
//                 textOverflow: `ellipses`
//               }}
//             />
//           </SearchBox>
//           <Marker
//             position={props.chosenPosition}
//             draggable
//             onDragEnd={props.onDragEnd}
//           />
//         </GoogleMap>
//       );
//     }
//     return (
//       <GoogleMap {...inputProps}>
//         <Marker
//           position={props.chosenPosition}
//           draggable
//           onDragEnd={props.onDragEnd}
//         />
//       </GoogleMap>
//     );
//   })
// );

const Map = ReactMapboxGl({
  accessToken
});

const POSITION_CIRCLE_PAINT = {
  "circle-stroke-width": 4,
  "circle-radius": 10,
  "circle-blur": 0.15,
  "circle-color": "#3770C6",
  "circle-stroke-color": "white"
};

class Location extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chosenPosition: [4.4005019, 50.8529654],
      actualPosition: null,
      locationHasBeenSet: false
      // height: window.innerHeight
    };
    // this.updateWindowHeight = this.updateWindowHeight.bind(this);
  }

  componentDidMount() {
    // this.updateWindowHeight();
    // window.addEventListener("resize", this.updateWindowHeight);

    navigator.geolocation.getCurrentPosition(position => {
      const newPosition = [position.coords.longitude, position.coords.latitude];
      this.setState({
        chosenPosition: newPosition,
        actualPosition: newPosition
      });
    });
  }

  // componentWillUnmount() {
  //   window.removeEventListener("resize", this.updateWindowHeight);
  // }

  // updateWindowHeight() {
  //   this.setState({ height: window.innerHeight });
  // }

  setNewPosition = e => {
    this.setState({
      chosenPosition: e.lngLat.toArray()
    });
  };

  onMapClick = (map, e) => {
    this.setNewPosition(e);
  };

  returnPositionCallback = () => {
    ReactGA.event({
      category: "Route",
      action: "Chose start location"
    });
    this.props.callback("startLocation", {
      lat: this.state.chosenPosition[1],
      lng: this.state.chosenPosition[0]
    });
  };

  resetToActualPosition = () => {
    if (this.state.actualPosition) {
      this.setState(state => {
        return { chosenPosition: state.actualPosition };
      });
    }
  };

  render() {
    const { chosenPosition, actualPosition } = this.state;
    const { classes } = this.props;
    const actualPositionButtonDisabled = actualPosition === null;

    const containerStyle = {
      height: "calc(100vh - 320px)",
      width: "100vw"
    };

    return (
      <div>
        <h1>Waar wil je starten?</h1>
        {/* <MyMapComponent
          isMarkerShown
          googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyA_1_ct8dynv8e4Dwu8QD_gXeaSEhl5GdU"
          loadingElement={<div style={{ height: "100%" }} />}
          containerElement={<div style={{ height: mapHeight }} />}
          mapElement={<div style={{ height: "100%" }} />}
          chosenPosition={chosenPosition}
          actualPosition={actualPosition}
          onClick={this.setNewPosition}
          onDragEnd={this.setNewPosition}
        /> */}
        <Map
          style="mapbox://styles/mapbox/outdoors-v9" // eslint-disable-line react/style-prop-object
          containerStyle={containerStyle}
          center={chosenPosition}
          onClick={this.onMapClick}
        >
          <Layer
            type="circle"
            id="position-marker"
            paint={POSITION_CIRCLE_PAINT}
          >
            <Feature
              coordinates={chosenPosition}
              draggable={true}
              onDragEnd={this.setNewPosition}
              // onDragEnd={evt => this.onDragEnd(evt, index)}
              // onDragStart={this.onDragStart}
              // onDrag={this.onDrag}
            />
          </Layer>
          {/* <Layer type="symbol" coordinates={[-0.2416815, 51.5285582]}>
            <Feature draggable={true}>
              FEATURE <img src={markerImage} alt="marker" />
            </Feature>
          </Layer> */}
          {/* <Marker
            coordinates={[-0.2416815, 51.5285582]}
            anchor="bottom"
            draggable={true}
          >
            <img src={markerImage} alt="marker" />
          </Marker> */}
          <Geocoder />
          <NavigationControl />
        </Map>
        <Button
          color="primary"
          className={classes.button}
          onClick={this.resetToActualPosition}
          disabled={actualPositionButtonDisabled}
        >
          Reset naar mijn huidige locatie
        </Button>
        <Button
          variant="raised"
          color="primary"
          className={classes.button}
          onClick={this.returnPositionCallback}
        >
          Daar ga ik vertrekken
        </Button>
      </div>
    );
  }
}

Location.propTypes = {
  classes: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired
};

export default withStyles(styles)(Location);



// WEBPACK FOOTER //
// ./src/NewRoute/components/Location.js